import { Api } from "../Api";
import { LogManager } from "../logging/LogManager";
import { StringUtil } from "../StringUtil";
import { SettingsRegistry } from "./SettingsRegistry";

export class SettingsLoader {
    private static readonly log = LogManager.getLogger("core.settings.SettingsLoader");

    static loadUnauthSettings(
        beforeSettingsApply: (response: any) => boolean,
        afterSettingsApply: (response: any, appliedSettings: boolean) => void,
        onError: (error: any) => void) {
        const unauthSettingsRoot = SettingsRegistry.get().unauthSettingsRoot;
        if (StringUtil.isEmptyString(unauthSettingsRoot)) {
            throw Error("Cannot determine settings endpoint due to missing root");
        }
        const unauthSettingsPath = `${unauthSettingsRoot}unauth-settings`;
        Api.search(
            unauthSettingsPath,
            { origin: window.location.origin },
            { sendAuth: false },
            ()=> {}
        ).then(async response => {
            const willApplySettings = beforeSettingsApply?.(response) ?? true;
            if (willApplySettings) {
                this.applySettings(response, false);
            }
            afterSettingsApply?.(response, willApplySettings);
        }).catch(error => {
            this.log.error(error);
            onError?.(error);
        });
    }

    static loadAuthSettings(
        beforeSettingsApply: (response: any) => boolean,
        afterSettingsApply: (response: any, appliedSettings: boolean) => void,
        onError: (error: any) => void) {
        const settingsRegistry = SettingsRegistry.get();
        const authSettingsRoot = settingsRegistry.authSettingsRoot;
        if (StringUtil.isEmptyString(authSettingsRoot)) {
            throw Error("Cannot determine settings endpoint due to missing root");
        }
        const authSettingsPath = `${authSettingsRoot}auth-settings`;
        const body = settingsRegistry.authSettingsBodyProvider?.() ?? {};
        Api.search(authSettingsPath, body).then(response => {
            const willApplySettings = beforeSettingsApply?.(response) ?? true;
            if (willApplySettings) {
                this.applySettings(response, true);
            }
            afterSettingsApply?.(response, willApplySettings);
        }).catch(error => {
            onError?.(error);
        });
    }

    private static applySettings(settingsObject: any, isAuth: boolean) {
        SettingsRegistry.update("general_settings", settingsObject, isAuth);
    }
}
